// Cookie-based wrapper around our /api/* Workers.
//
// Better Auth signs a session cookie at sign-in. `credentials: 'include'`
// sends that cookie on every same-origin request, replacing the old
// `Authorization: Bearer <jwt>` pattern from the Supabase build.

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers)
  // Default Content-Type to application/json only when the body is a string
  // (or untyped). For FormData/Blob/URLSearchParams the browser sets its own
  // header (with the multipart boundary, in FormData's case) — don't clobber.
  const isStructured =
    (typeof FormData !== 'undefined' && init?.body instanceof FormData) ||
    (typeof Blob !== 'undefined' && init?.body instanceof Blob) ||
    (typeof URLSearchParams !== 'undefined' && init?.body instanceof URLSearchParams)
  if (init?.body !== undefined && !isStructured && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  return fetch(path, { credentials: 'include', ...init, headers })
}

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await apiFetch(path, init)
  const text = await res.text()
  const parsed = text ? (JSON.parse(text) as unknown) : null
  if (!res.ok) {
    const message =
      (parsed && typeof parsed === 'object' && 'error' in parsed
        ? String((parsed as { error: unknown }).error)
        : null) ?? `request_failed_${res.status}`
    throw new Error(message)
  }
  return parsed as T
}
